import React from 'react';
import { FileIcon } from 'react-file-utils';

import { attachmentPreviewPropTypes } from '../../../utils/attachments';

import { FilePreviewContainer, FileIconContainer, FileTitle } from './styles';

const FileAttachment = ({
  assetLocalUrl,
  attachmentData: {
    title,
    mimeType,
  },
}) => (
  <FilePreviewContainer>
    <FileIconContainer onClick={() => window.open(assetLocalUrl)}>
      <FileIcon
        mimeType={mimeType}
        size={120}
        filename={title}
        big
      />
    </FileIconContainer>
    <FileTitle>{title}</FileTitle>
  </FilePreviewContainer>
);

FileAttachment.propTypes = attachmentPreviewPropTypes;

FileAttachment.defaultProps = {};

export default FileAttachment;
